import modelExtend from 'dva-model-extend'
import { basicModel, UPDATESTATE, addCookie, getCookie } from '@sisyphe/utils'
import * as api from 'services/login'

export default modelExtend(basicModel, {
  namespace: 'login',
  state: {
    userInfo: {
      token: getCookie('token'),
      userName: getCookie('userName'),
      roles: getCookie('roles') ? JSON.parse(getCookie('roles')) : [],
      enterpriseName: getCookie('enterpriseName'),
      shortName: getCookie('shortName'),
    },
  },
  reducers: {},
  effects: {
    /** 登录 */
    *login({ payload }, { call, put }) {
      const { data } = yield call(api.loginUsingPOST, payload)
      addCookie('token', data.token, '/')
      addCookie('userName', data.username, '/')
      addCookie('enterpriseName', data.enterpriseName, '/')
      addCookie('shortName', data.shortName, '/')
      addCookie('roles', JSON.stringify(data.roles), '/')

      yield put({
        type: 'login/setLoginInfo',
        payload: {
          token: data.token,
          userName: data.username,
          roles: data.roles,
          enterpriseName: data.enterpriseName,
          shortName: data.shortName,
        },
      })

      return data
    },
    *setLoginInfo({ payload }, { call, put }) {
      yield put({
        type: UPDATESTATE,
        payload: {
          userInfo: payload,
        },
      })
    },
  },
})
